const PIXEL_ID = '1067482413124780'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

/**
 * Injects the Meta Pixel base code and fires the initial PageView.
 * Safe to call multiple times — it will only initialize once.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) return /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/** Fires the standard AddToCart event (used right before redirecting to Shopify). */
export function trackAddToCart(): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', 'AddToCart')
}
